import "./number"
import "./gapmoment"

String.prototype.maskAsKakaoAccount = function () {
  let id = this.split('::')[0];
  if (id === 'UNKNOWN'){
    return "탈퇴유저";
  }
  if (this.split('::')[1] !== 'KAKAO') {
    // LDAP 아이디는 마스킹 안함
    return id;
  }
  return id.substr(0, 4) + "*".repeat(id.length - 4);
};

String.prototype.splitFirstAsKakaoAccount = function () {
  let id = this.split('::')[0];
  if (id === 'UNKNOWN'){
    return "탈퇴유저";
  }
  return id;
};

String.prototype.maskAsName = function () {
  switch (this.length) {
  case 1:
    return this;
  case 2:
    return this[0] + "*";
  default:
    return this[0] + "*".repeat(this.length - 2) + this[this.length - 1];
  }
};

String.prototype.getValueFromKeyValueMapString = function(key){
  const regex = new RegExp(`${key}=\\[(\\w*)\\]`);
  if(regex.test(this)){
    return regex.exec(this)[1];
  }
  return false;
};

String.prototype.prependHttps = function () {
  if (this.startsWith("http://") ||
      this.startsWith("https://")) {
    return this;
  }
  return "https://" + this;
}
